import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { Card, Icon } from 'components';
import { ServiceLimit } from './ServiceLimit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const Cards = ({ isProcessing, accumulators = [] }) => (
  <div className={cn('container')}>
    {accumulators.map((accumulator) => (
      <Card color="grey" key={accumulator.name}>
        <div className={cn('card')}>
          <div className={cn('card__title')}>
            <Text>{accumulator.name}</Text>
          </div>
          <div className={cn('card__icon-wrapper')}>
            <Icon name={accumulator.image} className={cn('card__icon')} />
          </div>
          <ServiceLimit
            isProcessing={isProcessing}
            balance={accumulator.balance}
            limit={accumulator.limit}
            unit={accumulator.unit}
            unlimited={accumulator.unlimited}
          />
        </div>
      </Card>
    ))}
  </div>
);

Cards.propTypes = {
  isProcessing: PropTypes.bool,
  accumulators: PropTypes.arrayOf({
    balance: PropTypes.string,
    limit: PropTypes.string,
    unit: PropTypes.string,
    unlimited: PropTypes.bool,
  }),
};

export { Cards };
